export default __webpack_public_path__ + "static/img-2-941739adc3373329ef3bc1b980283847.png";